import Vue from 'vue';
import Vuex from 'vuex';

import accounts from './modules/accounts';
import agentBots from './modules/agentBots';
import agents from './modules/agents';
import articles from './modules/helpCenterArticles';
import attributes from './modules/attributes';
import auth from './modules/auth';
import auditlogs from './modules/auditlogs';
import automations from './modules/automations';
import billing from './modules/billing';
import bulkActions from './modules/bulkActions';
import campaigns from './modules/campaigns';
import cannedResponse from './modules/cannedResponse';
import categories from './modules/helpCenterCategories';
import contactConversations from './modules/contactConversations';
import contactLabels from './modules/contactLabels';
import contactNotes from './modules/contactNotes';
import contacts from './modules/contacts';
import conversationLabels from './modules/conversationLabels';
import contactViewConversationLabels from './modules/contactViewConversationLabels';
import conversationMetadata from './modules/conversationMetadata';
import contactViewConversationMetadata from './modules/contactViewConversationMetadata';
import conversationPage from './modules/conversationPage';
import contactViewConversationPage from './modules/contactViewConversationPage';
import conversations from './modules/conversations';
import contactViews from './modules/contactViews';
import conversationSearch from './modules/conversationSearch';
import contactViewConversationSearch from './modules/contactViewConversationSearch';
import conversationStats from './modules/conversationStats';
import contactViewConversationStats from './modules/contactViewConversationStats';    
import conversationTypingStatus from './modules/conversationTypingStatus';
import contactViewConversationTypingStatus from './modules/contactViewConversationTypingStatus';
import conversationWatchers from './modules/conversationWatchers';
import contactViewConversationWatchers from './modules/contactViewConversationWatchers';
import csat from './modules/csat';
import customViews from './modules/customViews';
import dashboardApps from './modules/dashboardApps';
import globalConfig from 'shared/store/globalConfig';
import inboxAssignableAgents from './modules/inboxAssignableAgents';
import inboxes from './modules/inboxes';
import inboxMembers from './modules/inboxMembers';
import intelligenceDashboard from './modules/intelligenceDashboard';
import integrations from './modules/integrations';
import labels from './modules/labels';
import macros from './modules/macros';
import notifications from './modules/notifications';
import portals from './modules/helpCenterPortals';
import reports from './modules/reports';
import sla from './modules/sla';
import teamMembers from './modules/teamMembers';
import teams from './modules/teams';
import userNotificationSettings from './modules/userNotificationSettings';
import webhooks from './modules/webhooks';
import draftMessages from './modules/draftMessages';
import SLAReports from './modules/SLAReports';
import flows from './modules/flows';
import campaignsManager from './modules/campaignsManager';
import contactsAndConversations from './modules/contactsAndConversations';
import aiAgents from './modules/aiAgents.js';
import telephony from './modules/telephony';
import whatsappCalling from './modules/whatsappCalling';

const plugins = [];

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    accounts,
    agentBots,
    agents,
    articles,
    attributes,
    flows,
    auth,
    automations,
    auditlogs,
    billing,
    bulkActions,
    campaigns,
    campaignsManager,
    cannedResponse,
    categories,
    contactConversations,
    contactViews,
    contactLabels,
    contactNotes,
    contacts,
    conversationLabels,
    contactViewConversationLabels,
    conversationMetadata,
    contactViewConversationMetadata,
    conversationPage,
    contactViewConversationPage,
    conversations,
    contactConversations,
    conversationSearch,
    contactViewConversationSearch,
    conversationStats,
    contactViewConversationStats,
    conversationTypingStatus,
    contactViewConversationTypingStatus,
    conversationWatchers,
    contactViewConversationWatchers,
    csat,
    customViews,
    dashboardApps,
    globalConfig,
    inboxAssignableAgents,
    inboxes,
    inboxMembers,
    intelligenceDashboard,
    integrations,
    labels,
    macros,
    notifications,
    portals,
    reports,
    teamMembers,
    teams,
    userNotificationSettings,
    webhooks,
    draftMessages,
    sla,
    slaReports: SLAReports,
    contactsAndConversations,
    aiAgents,
    telephony,
    whatsappCalling
  },
  plugins,
});
